const blankBuilder = () => {
  const grid = [[]];

  const metadata = {
    views: [],
    columnStyles: [],
    rowStyles: [],
  };

  return {
    metadata,
    grid,
  };
};

export default blankBuilder;
